import { CheckInput, TextInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import SectionTitle from '../../../../../../components/text/SectionTitle';
import { useValidations } from '../../../../../../hooks/useValidations';

const prefix = 'tariffAndTuition.subsidies';

interface FormValues {
  name: string;
  applyAutomatically: boolean;
  periodAmounts: { [key: number]: string };
}

const SubsidyDataSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const { msgValidations, validateTextNotEmpty } = useValidations();

  return (
    <>
      <Row className="mb-3">
        <Col xs="12">
          <SectionTitle text={t(`${prefix}.subsidyData`)} />
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6">
          <TextInput
            name="name"
            label={t(`${prefix}.compensationBoxName`)}
            placeholder={t(`${prefix}.compensationBoxPlaceholder`)}
            control={control}
            rules={{
              required: msgValidations.required,
              validate: validateTextNotEmpty,
            }}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs="12">
          <CheckInput
            name="applyAutomatically"
            label={t(`${prefix}.applyAutomatically`)}
            control={control}
          />
        </Col>
      </Row>
    </>
  );
};

export default SubsidyDataSection;
